import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useBookingAppointmentOptions } from 'hooks';
import BookAppointmentService from './BookAppointmentService';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function BookAppointmentOptions({ onSelectOption }) {
  const classes = useStyles();
  const { data: bookingOptions } = useBookingAppointmentOptions();

  return bookingOptions.map(({ name, info, id }) => (
    <BookAppointmentService key={id} onClick={onSelectOption(id)}>
      <>
        <Typography className={classes.capitalizedTitle} variant="h6" component="h6" noWrap>
          {name}
        </Typography>
        <Typography className={classes.serviceDescription} variant="body1" component="div">
          {info}
        </Typography>
      </>
    </BookAppointmentService>
  ));
}

BookAppointmentOptions.propTypes = {
  onSelectOption: PropTypes.func.isRequired,
};

export default BookAppointmentOptions;
